import React, {useEffect} from 'react';
import styled from 'styled-components';

import AnalyticsService from './../../services/AnalyticsService';

import Meta from './../layout/Meta';
import Layout from '../layout/Layout';
import Section from '../layout/Section';
import Padding from '../layout/Padding';
import Row from './../../common/components/Row';
import Col from './../../common/components/Col';
import Typo from './../../common/components/Typo';

const Map = styled.div`
  margin-bottom: -6px;
`;


const Contatti = ({layout}) => {
  useEffect(() => {
    AnalyticsService.init();  
  }, []);

  let iframe = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63780.100267246715!2d11.028596878354557!3d45.051130058384615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4781d55c471505bd%3A0xa4d05541d6921b94!2sA.C.S.%20Autoriparazioni%20Camper%20Service%20di%20Meneghel%20Mirko%20e%20Juri%20Sas!5e0!3m2!1sit!2sit!4v1740494039305!5m2!1sit!2sit" width="100%" height="500" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>';
  return (
    <Layout layout={layout}>
      <Meta
        title={"Contatti"}
        description={"Contattaci per informazioni, preventivi o appuntamenti in provincia di Mantova e dintorni"}
      />

      <Map dangerouslySetInnerHTML={{__html: iframe}} />
      <Section
        variant="white" 
        imageDx={"/web/sections/contatti-contatti.jpg"}
        minHeight="500px"
      >
        <Padding top right bottom left>
          <Typo type="h1">Contatti</Typo>
          <Typo type="p">Per informazioni, preventivi o appuntamenti, non esitare a chiamarci o scriverci!</Typo>
        </Padding>
     </Section>
     <Section variant="lightblue">
        <Padding top right bottom left>
          <Row>
           <Col widthmd={6}>
              <Typo type="h3" align="center">
                Indirizzo
              </Typo>
              <Typo type="p" align="center">
                ACS Autoriparazioni Camper Service<br/>di Meneghel Mirko e Meneghel Juri e C SAS<br/>
                Via dell'Alpino 22,<br/>San Biagio di Bagnolo San Vito (MN)<br/>
                P. IVA: 01892860204
              </Typo>
            </Col>
            <Col widthmd={6}>
              <Typo type="h3" align="center">
                Contatti
              </Typo>
              <Typo type="p" align="center">
                <a href="tel:+390376253305" target="_blank" rel="noreferrer">Tel: 0376 253305</a><br/>
                <a href="autofficinaacs@gmail.com" target="_blank" rel="noreferrer">Email: autofficinaacs@gmail.com</a><br/>
                <a href="a.c.s.autofficina@legalmail.it" target="_blank" rel="noreferrer">PEC: a.c.s.autofficina@legalmail.it</a>
              </Typo>
            </Col>
          </Row>
        </Padding>
      </Section>
    </Layout>
  )
}

export default Contatti
